import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useSelector } from 'react-redux';
import { T, useTranslate } from 'shared/helper/translate';
// import { getShowEditingCertificate } from 'researcher/order-form/order/reducer/index';

// import NewOrderNotice from './NewOrderNotice';
import OrderCertificate from './OrderCertificate';
import OrderReeditLink from './OrderReeditLink';
import SharePreprint from './SharePreprint';
var downloadAvailabilityFromOrder = function downloadAvailabilityFromOrder(order) {
  if (!order) {
    return {
      message: 'completed-files-message-not-ready'
    };
  }
  var awaitingPayment = order.completed && !order.downloadAvailable;
  var available = order.completed && order.downloadAvailable;
  var message = available ? 'completed-files-message-ready' : 'completed-files-message-not-ready';
  if (awaitingPayment) {
    message = 'completed-files-awaiting-payment';
  }
  return {
    message: message,
    available: available
  };
};
var OrderDetailsContent = function OrderDetailsContent(_ref) {
  var addMessage = _ref.addMessage,
    displayPreprintCampaign = _ref.displayPreprintCampaign,
    fetchOrderCertificate = _ref.fetchOrderCertificate,
    getDownloadUrl = _ref.getDownloadUrl,
    newOrder = _ref.newOrder,
    order = _ref.order,
    reeditMessageTerm = _ref.reeditMessageTerm,
    siteLanguage = _ref.siteLanguage,
    status = _ref.status,
    updateCertificate = _ref.updateCertificate,
    updateEmailNotificationSettings = _ref.updateEmailNotificationSettings;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  // const showEditingCertificate = useSelector(getShowEditingCertificate);

  var downloadAvailability = downloadAvailabilityFromOrder(order);
  var proofOfPaymentSupportLink = "/support/index/submission/".concat(order.externalId, "/type/proof-of-payment");

  // if (newOrder) {
  //     return (
  //         <NewOrderNotice
  //             fetchOrderCertificate={fetchOrderCertificate}
  //             order={order}
  //             status={status}
  //             updateCertificate={updateCertificate}
  //             updateEmailNotificationSettings={updateEmailNotificationSettings}
  //             siteLanguage={siteLanguage}
  //             displayPreprintCampaign={displayPreprintCampaign}
  //         />
  //     );
  // }

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "row mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "Completed files"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: downloadAvailability.message,
    inline: true,
    params: {
      supportLink: proofOfPaymentSupportLink
    }
  }), downloadAvailability.available ? /*#__PURE__*/React.createElement("br", null) : null, downloadAvailability.available ? /*#__PURE__*/React.createElement(React.Fragment, null, order.retrievingDownload ? /*#__PURE__*/React.createElement("span", {
    className: "btn btn-primary action-button text-uppercase btn-small mt-2"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-spinner-scale",
    className: "me-2",
    spin: true,
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(T, {
    source: "Downloading..."
  }), /*#__PURE__*/React.createElement("span", {
    className: "ps-1"
  }, order.downloadPercentage, "%")) : /*#__PURE__*/React.createElement("button", {
    "aria-label": t('Download All Files'),
    type: "button",
    onClick: function onClick() {
      return getDownloadUrl(order.externalId);
    },
    className: "btn btn-primary action-button text-uppercase btn-small mt-2"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "me-2",
    icon: "fa-solid fa-download",
    "aria-hidden": "true"
  }), /*#__PURE__*/React.createElement(T, {
    source: "Download All Files"
  }))) : null)), order.completed ? /*#__PURE__*/React.createElement("div", {
    className: "row mt-4"
  }, order.certificateReady && order.certificate ? /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md"
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "Your Editing Certificate"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "editing-certificate-message-ready",
    inline: true
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement(OrderCertificate, {
    addMessage: addMessage,
    saving: order.status.savingCertificate,
    order: order,
    updateCertificate: updateCertificate
  })) : null, order.downloadAvailable && (order.touchUpAvailable || order.reeditAvailable) ? /*#__PURE__*/React.createElement("div", {
    className: "col-12 col-md"
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: order.touchUpAvailable ? 'Submit for a Free Re-edit' : 'Submit for re-edit'
  })), /*#__PURE__*/React.createElement(T.md, {
    source: order.touchUpAvailable ? 'reedit-message-free' : reeditMessageTerm,
    inline: true
  }), /*#__PURE__*/React.createElement(OrderReeditLink, {
    order: order
  })) : null) : /*#__PURE__*/React.createElement(React.Fragment, null, order.certificate || showEditingCertificate ? /*#__PURE__*/React.createElement("div", {
    className: "row mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "Your Editing Certificate"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "editing-certificate-message-not-ready",
    inline: true
  }))) : null), /*#__PURE__*/React.createElement("div", {
    className: "row mt-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement(T, {
    source: "Ask a question about this order"
  })), /*#__PURE__*/React.createElement(T.md, {
    source: "contact-support-message",
    inline: true
  }), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("a", {
    "aria-label": t('Contact support'),
    className: "btn btn-primary text-uppercase btn-small mt-2",
    href: "/support/index/submission/".concat(order.externalId, "/type/support"),
    target: "_blank",
    rel: "noopener noreferrer"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Contact support"
  })))), displayPreprintCampaign ? /*#__PURE__*/React.createElement(SharePreprint, {
    campaignName: "order-details-module-".concat(siteLanguage)
  }) : null);
};
export default OrderDetailsContent;